import {
  WORKAREAS_FETCH_FAIL,
  WORKAREAS_FETCH_REQUEST,
  WORKAREAS_FETCH_SUCCESS,
} from "../constants/WorkAreaConstants";
import { getAllWorkAreas } from "../services/workAreaService";

export const fetchWorkAreas = () => async (dispatch) => {
  dispatch({ type: WORKAREAS_FETCH_REQUEST });

  try {
    const data = await getAllWorkAreas();
    dispatch({ type: WORKAREAS_FETCH_SUCCESS, payload: Array.isArray(data) ? data : [] });
    return Array.isArray(data) ? data : [];
  } catch (error) {
    const message =
      error?.response?.data?.message || error?.message || "Failed to fetch work areas.";
    dispatch({ type: WORKAREAS_FETCH_FAIL, payload: message });
    throw error;
  }
};